module.exports = __webpack_public_path__ + "19fa589eb237af8a5780650d78c927aa.png";